import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material';
import { CashbackModel } from '../../../utils/cashbackConstants';
import { CashbackEstimationChart } from './CashbackEstimationChart';
import { InputSlider } from './InputSlider';

const DEFAULT_PORTFOLIO_COMMISSION = 0.005;

const ChartContainer = styled('div')(({ theme }) => ({
  height: '500px',
  width: '100%',
  [theme.breakpoints.only('xs')]: {
    height: '350px',
    width: '100%',
    alignSelf: 'flex-end',
    marginBottom: '30px',
  },
}));

export interface Props {
  model?: CashbackModel;
}

export const CashbackEstimationChartWithInputSlider = ({ model = 'flat-fee' }: Props) => {
  const [wealth, setWealth] = useState<number>(150000);
  const { t } = useTranslation();

  const handleChange = (value: number) => {
    if (value) {
      setWealth(value);
    }
  };

  return (
    <div>
      <ChartContainer>
        <CashbackEstimationChart
          wealth={wealth}
          portfolioCommissionPercent={DEFAULT_PORTFOLIO_COMMISSION}
          model={model}
        />
      </ChartContainer>

      <InputSlider
        label={t('cashbackCalculator.detailed.inputSlider.label')}
        defaultValue={wealth}
        maxValue={500000}
        onChange={handleChange}
      />
    </div>
  );
};
